<template>
  <div
    class="like"
    :class="{ active: likeOpts.isLiked, reverse: isReverse }"
    @click="handleToggleLike"
  >
    <div class="like-wrap">
      <div
        v-if="isShowCount"
        class="like__count"
      >
        {{ likeOpts.count }}
      </div>

      <div class="like__icon">
        <UiIcon
          class="like__icon-svg"
          name="heart"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IOptions } from '~/types/analytics';

const props = defineProps<{
  likesCount?: number,
  isLiked?: boolean,
  isReverse?: boolean,
  isHideZero?: boolean,
  analytics?: IOptions,
  productId: number,
}>();

const { t } = useI18n();
const { isAuth, openAuthDialog } = useAccountStore();
const { toggleLike } = useWishlistStore();
const { openPhoneVerifyDialog, phoneVerifyWebPopup } = usePhoneVerification();

let isToggling = false;

const likeOpts = reactive({
  count: props.likesCount ?? 0,
  isLiked: props.isLiked ?? false,
});

const isShowCount = computed<boolean>(() => (likeOpts.count > 0 ? true : props.isHideZero !== true));

async function handleToggleLike() {
  if (!isAuth.value) {
    openAuthDialog({ chapter: 'product_like' });

    return;
  }

  if (isToggling) return;
  isToggling = true;

  if (!likeOpts.isLiked && phoneVerifyWebPopup.value?.addToFavorites) {
    openPhoneVerifyDialog({
      chapter: 'addToFavorites',
      phoneText: t('ui.likesCount.addToFavorites.phoneText'),
    });
  }

  try {
    const res = await toggleLike(props.productId, likeOpts.isLiked, undefined, undefined, props.analytics);

    if (res) {
      if (likeOpts.isLiked) {
        likeOpts.isLiked = false;
        likeOpts.count--;
      } else {
        likeOpts.isLiked = true;
        likeOpts.count++;
      }
    }
    isToggling = false;
  } catch {
    isToggling = false;
  }
}
</script>

<style lang="scss">
@tailwind components;

@layer components {
  .like {
    @apply h-full flex items-center justify-center cursor-pointer;
    &-wrap {
      @apply flex -mx-0.5;
    }
    &.reverse .like-wrap {
      @apply flex-row-reverse;
    }
    &__count {
      @apply text-red-500 px-0.5;
    }
    &__icon {
      @apply px-0.5 w-6 h-6 box-content;
      & path {
        @apply fill-transparent;
      }
    }
    &:hover &__icon path,
    &.active &__icon path {
      @apply fill-red-500;
    }
  }
}
</style>
